export default __webpack_public_path__ + "static/media/ic-sm-grazing-3.5f136f95.svg";